export default {
  name: "StoreValue",

  props: {
    storeName: {
      required: true,
      type: String
    },
    accessPoint: {
      required: true,
      type: String,
      validator: (value) => {
        const validProps = ['state', 'getters', 'actions', '_actions', '_mutations'];
        return validProps.includes(value);
      }
    },
    propName: {
      required: true,
      type: String
    }
  },

  render() {
    let valueToPass;
    const namespacedProp = `${this.storeName}/${this.propName}`;

    if (!this.$store) {
      valueToPass = undefined;
    } else if (this.accessPoint === 'state') {
      valueToPass = this.$store.state?.[this.storeName]?.[this.propName];
    } else if (this.accessPoint === 'actions') {
      valueToPass = this.$store._actions?.[namespacedProp]?.[0];
    } else {
      if (this.accessPoint in this.$store && this.$store[this.accessPoint]) {
        valueToPass = this.$store[this.accessPoint][namespacedProp];
      } else {
        valueToPass = undefined;
      }
    }

    if (this.$slots.default) {
      return this.$slots.default({
        value: valueToPass
      });
    } else {
      return null;
    }
  },
};
